(function () {
  if (window.ftMobileTextureReady) return;
  window.ftMobileTextureReady = true;

  var touch = window.matchMedia('(hover: none), (pointer: coarse)');
  var scheduled = false;
  var serial = 0;

  function setPreview(frame, visible) {
    var button = frame.querySelector('.ft-texture-toggle');
    if (!button) return;
    frame.classList.toggle('is-texture-visible', visible);
    button.setAttribute('aria-pressed', String(visible));
    button.setAttribute('aria-label', 'Show ' + (visible ? 'product photo' : 'texture') + ' for ' + button.dataset.productName);
  }

  function enhance() {
    if (!touch.matches) return;
    document.querySelectorAll('.ft-pc, .product-item-parent').forEach(function (card) {
      if (card.dataset.ftAltMode === 'moss' || card.dataset.ftAltMode === 'none') return;
      var media = card.querySelector('.ft-pc__media, .grid__image');
      if (!media || media.parentElement.classList.contains('ft-texture-media')) return;
      var alternate = media.querySelector('.ft-alt, .ft-kit-swatches, .product-image--hover .ft-card-swatch');
      if (!alternate) return;
      var isSet = alternate.classList.contains('ft-kit-swatches');
      var sourceImages = isSet ? Array.from(alternate.querySelectorAll('img')).slice(0, 4) : (alternate.matches('img') ? [alternate] : []);
      if (!sourceImages.length) return;

      var frame = document.createElement('div');
      frame.className = 'ft-texture-media';
      media.parentNode.insertBefore(frame, media);
      frame.appendChild(media);
      if (!media.id) media.id = 'ft-texture-photo-' + (++serial);

      var name = card.querySelector('.ft-pc__name, .product-grid-item__title');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ft-texture-toggle';
      button.dataset.productName = name ? name.textContent.trim() : 'this product';
      button.setAttribute('aria-controls', media.id);
      var face = document.createElement('span');
      face.className = 'ft-texture-toggle__face';
      face.setAttribute('aria-hidden', 'true');
      var swatch = document.createElement('span');
      swatch.className = 'ft-texture-toggle__swatch' + (isSet ? ' is-set' : '');
      sourceImages.forEach(function (source) {
        var thumbnail = source.cloneNode(false);
        Array.from(thumbnail.attributes).forEach(function (attribute) {
          if (attribute.name !== 'src' && attribute.name !== 'srcset') thumbnail.removeAttribute(attribute.name);
        });
        thumbnail.setAttribute('sizes', '28px');
        thumbnail.setAttribute('alt', '');
        thumbnail.setAttribute('aria-hidden', 'true');
        swatch.appendChild(thumbnail);
      });
      face.appendChild(swatch);
      var back = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      back.setAttribute('class', 'ft-texture-toggle__return');
      back.setAttribute('viewBox', '0 0 24 24');
      back.setAttribute('fill', 'none');
      back.setAttribute('stroke', 'currentColor');
      back.setAttribute('stroke-width', '1.25');
      back.setAttribute('stroke-linecap', 'round');
      back.setAttribute('stroke-linejoin', 'round');
      back.setAttribute('aria-hidden', 'true');
      back.setAttribute('focusable', 'false');
      var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      arrow.setAttribute('d', 'M19 12H5m6-6-6 6 6 6');
      back.appendChild(arrow);
      face.appendChild(back);
      button.appendChild(face);
      frame.appendChild(button);
      setPreview(frame, false);
    });
  }

  function schedule() {
    if (scheduled || !touch.matches) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      enhance();
    });
  }

  function start() {
    enhance();
    document.addEventListener('click', function (event) {
      if (!touch.matches || !(event.target instanceof Element)) return;
      var button = event.target.closest('.ft-texture-toggle');
      if (!button) return;
      event.preventDefault();
      var frame = button.closest('.ft-texture-media');
      setPreview(frame, !frame.classList.contains('is-texture-visible'));
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.ft-texture-media.is-texture-visible').forEach(function (frame) {
        setPreview(frame, false);
      });
    });
    document.addEventListener('shopify:section:load', schedule);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    touch.addEventListener('change', function () {
      if (touch.matches) {
        enhance();
      } else {
        document.querySelectorAll('.ft-texture-media.is-texture-visible').forEach(function (frame) {
          setPreview(frame, false);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());

